import { useCookies } from 'react-cookie';
import { GEO_LOCATION_COOKIE_NAME } from 'shared/custom/constants/commonConstants';

export const useCurrentPhysicalStoreId = (props?: { defaultPhysicalStoreId?: string }) => {
	const [cookies] = useCookies([GEO_LOCATION_COOKIE_NAME]);

	const physicalStoreId = cookies?.geoLocationHDP?.stLocId as string | null | undefined;
	const hasPreviousAnswer = !!cookies?.geoLocationHDP?.hasPreviousAnswer;

	if (hasPreviousAnswer && physicalStoreId) {
		return {
			physicalStoreId,
		};
	}

	return {
		physicalStoreId: props?.defaultPhysicalStoreId ?? null,
	};
};
